<template>
  <div v-if="boxshow" data-v-ef9b135b="" data-v-50146626="" class="dialog pcDialog" style="">
    <!-- 登录 -->
    <div data-v-ef9b135b="" class="wrap" v-if="step == 1">
      <div data-v-567a9db6="" data-v-50146626="" class="login pcLogin">
        <p data-v-567a9db6="" class="welcome">{{ $t('_a._wct') }} ReelShortPro</p>
        <div class="bodet1 sdfktbox">
          <!-- <div>
                        <span class="bem">邮箱:</span>
                    </div> -->
          <div>
            <input class="bdipt" v-model="signin.email" type="text" :placeholder="$t('_dl._qssyx')" />
          </div>
        </div>
        <div class="bodet1 sdfktbox">
          <div>
            <input class="bdipt" v-model="signin.passwd" type="password" :placeholder="$t('_dl._qssmm')" />
          </div>
        </div>
        <button data-v-567a9db6="" class="login" @click="onLoginSubmit">{{ $t('_dl._ann') }}</button>
        <p data-v-567a9db6="" class="notice">
          {{ $t('_dl._hmyzh') }}
          <a data-v-567a9db6="" @click="onSignup">{{ $t('_dl._qzc') }}</a>
        </p>
      </div>
      <span data-v-ef9b135b="" class="close" @click="close"></span>
    </div>

    <!-- 注册 -->
    <div data-v-ef9b135b="" class="wrap" v-if="step == 2">
      <div data-v-567a9db6="" data-v-50146626="" class="login pcLogin">
        <p data-v-567a9db6="" class="welcome">Welcome to ReelShortPro</p>
        <p data-v-567a9db6="" class="notice" style="text-align: left; margin-left: 50px">
          {{ $t('_dl._yzhl') }}
          <a data-v-567a9db6="" @click="onLogin">{{ $t('_dl._qdl') }}</a>
        </p>
        <div class="bodet1 sdfktbox">
          <div>
            <input class="bdipt" v-model="signup.email" type="text" :placeholder="$t('_dl._qssyx')" />
          </div>
        </div>
        <div class="bodet1 sdfktbox">
          <div>
            <input class="bdipt" v-model="signup.passwd" type="password" :placeholder="$t('_dl._qssmm')" />
          </div>
        </div>
        <div class="bodet1 sdfktbox">
          <div>
            <input class="bdipt" v-model="signup.confirm_passwd" type="password" :placeholder="$t('_dl._srqrmm')" />
          </div>
        </div>
        <div class="bodet1 sdfktbox" v-if="inv_code_show">
          <div>
            <input class="bdipt" v-model="signup.inv_code" type="text" :placeholder="$t('_dl._sryqm')" />
          </div>
        </div>
        <div class="bodet1 sdfktbox">
          <div class="dlefsyzm">
            <input class="bdipt fsyzm" v-model="signup.code" type="text" :placeholder="$t('_dl._sryzm')" style="width: 65%" />
            <button class="fsyzm fsan" @click="onSendCode()">{{ codeBtnText }}</button>
          </div>
        </div>
        <button data-v-567a9db6="" class="login" @click="onSignupSubmit">{{ $t('_dl._ljzc') }}</button>
        <p data-v-567a9db6="" class="notice">
          {{ $t('_dl._zcbsty') }}
          <a data-v-567a9db6="" href="/privacyPolicy">{{ $t('_dl._yszc') }}</a>
        </p>
      </div>
      <span data-v-ef9b135b="" class="close" @click="close"></span>
    </div>
  </div>
</template>

<script>
import { countdown } from '@/utils/tools'
export default {
  name: 'LoginVue',
  data() {
    return {
      boxshow: false,
      step: 1,
      //登录
      signin: {
        email: '',
        passwd: ''
      },

      hasSend: true,
      codeBtnText: this.$t('_yzm._fsyzm'),

      //邀请码
      inv_code_show: true,
      signup: {
        email: '',
        passwd: '',
        confirm_passwd: '',
        inv_code: '', //MuzIB2
        code: '',
        inv_uid: '',
        gift_code: '',
        gift_uuid: ''
      }
    }
  },
  methods: {
    show(v, inv_code, gift_code, gift_uuid) {
      if (v) {
        this.step = v
      }
      //邀请码
      if (inv_code) {
        this.signup.inv_code = inv_code
        this.inv_code_show = false
      }
      //注册有礼
      if (gift_code && gift_uuid) {
        this.signup.gift_code = gift_code
        this.signup.gift_uuid = gift_uuid
      }
      this.boxshow = true
    },
    close() {
      this.boxshow = false
    },
    onLogin() {
      this.step = 1
    },
    onSignup() {
      this.step = 2
    },
    validSignin() {
      if (!this.signin.email) {
        this.$message.error(this.$t('_dl._qssyx'))
        return false
      }
      if (!this.signin.passwd) {
        this.$message.error(this.$t('_dl._qssmm'))
        return false
      }
      return true
    },
    onLoginSubmit() {
      if (!this.validSignin()) {
        return
      }

      this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })

      this.$api.user
        .signin(this.signin)
        .then((res) => {
          if (res.code !== 0) {
            // this.$message.error(res.message)
            return
          }
          //缓存登录标识
          localStorage.setItem(this.$Const.KEY_TOKEN, res.data.token)
          localStorage.setItem(this.$Const.KEY_INFO, JSON.stringify(res.data.info))

          this.$message.success({ content: res.msg, key: 'msg' })
          this.close()
          this.$emit('signinSuccess')
          window.location.href = '/'
        })
        .catch(() => {})
    },
    /**
     * 发送验证码
     */
    onSendCode() {
      if (!this.hasSend) {
        return
      }
      let email = this.$common.rmSpaces(this.signup.email)
      let key = this.$md5(email)

      this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })

      let that = this
      this.$api.code
        .sendCode({
          email: email,
          scene: 'signup'
        })
        .then((res) => {
          that.$message.success({
            content: this.$t('_yzm._fscg') /* + ",code:" + res.data.code*/,
            key: 'msg'
          })
          countdown.start(key, res.data.exp)
          countdown.run(key, that.CallTime)
        })
    },
    /**
     * 倒计时回调
     * @param {*} time
     */
    CallTime(time) {
      console.log(time)
      if (time == 0) {
        this.hasSend = true
        this.codeBtnText = this.$t('_yzm._fsyzm')
      } else {
        this.hasSend = false
        this.codeBtnText = this.$t('_yzm._cxfs', {
          time: time
        })
      }
    },
    validSignup() {
      if (!this.signup.email) {
        this.$message.error(this.$t('_dl._qssyx'))
        return false
      }
      if (!this.signup.passwd) {
        this.$message.error(this.$t('_dl._qssmm'))
        return false
      }
      if (this.signup.passwd !== this.signup.confirm_passwd) {
        this.$message.error(this.$t('_dl._lcmmbyy'))
        return false
      }
      if (!this.signup.inv_code) {
        this.$message.error(this.$t('_dl._sryqm'))
        return false
      }
      if (!this.signup.code) {
        this.$message.error(this.$t('_dl._sryzm'))
        return false
      }
      return true
    },
    onSignupSubmit() {
      if (!this.validSignup()) {
        return
      }

      this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })

      this.$api.user
        .signup(this.signup)
        .then((res) => {
          if (res.code !== 0) {
            // this.$message.error(res.message)
            return
          }
          this.$message.success({ content: res.msg, key: 'msg' })
          this.onLogin()
          this.$emit('signupSuccess')
        })
        .catch(() => {})
    }
  }
}
</script>

<style>
.bodet1 {
  padding: 10px 50px;
}

.bdipt {
  border: 1px solid #f3f3f3;
  border-radius: 25px;
  width: 100%;
  height: 45px;
  padding: 0 15px;
}

.sdfktbox {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sdfktbox .bem {
  font-size: 15px;
}

.pcLogin .login {
  border-radius: 26px;
  display: block;
  font-family: Ubuntu-Medium;
  font-size: 16px;
  font-weight: 500;
  height: 52px;
  margin: auto;
  position: relative;
  width: 304px;
}

.pcLogin .login {
  background: #266fff;
  color: #fff;
  margin-bottom: 22px;
}

.dlefsyzm {
  display: flex;
  align-items: center;
}

.fsyzm {
  flex: 1;
}

.fsan {
  text-align: center;
}
</style>
